export type SupportedLanguage = 'English' | 'Espanol';
export const defaultLanguage: SupportedLanguage = 'English';
export const supportedLanguages: SupportedLanguage[] = ['English', 'Espanol'];

export type I18nLanguage = 'en-US' | 'es-ES';
export const defaultI18nLanguage: I18nLanguage = 'en-US';
export const supportedI18nLanguage: I18nLanguage[] = ['en-US', 'es-ES'];
